import { z } from "zod/v4";

/**
 * Search params schema for class statistics. `leerjaar`/`tab` are read/written by the shared
 * `AveragesTable` component; keep in sync with `dashboard.tsx`'s `dashboardSearchSchema`.
 */
export const statisticsSearchSchema = z.object({
  klasId: z.string().optional(),
  leerjaar: z.string().optional(),
  tab: z.string().optional(),
});

export type StatisticsSearch = z.infer<typeof statisticsSearchSchema>;
